export enum BadgeColor {
  RED = 'RED',
  BLUE = 'BLUE',
  YELLOW = 'YELLOW'
}
